import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Grid, Row, Stack, Text } from 'rsuite';
import { selectConfigExpressParcelVerbiage } from '../../store/slices/config/configSelectors';

const SelectedProperty = ({ propertyDetails, ...rest }) => {
  const selectedParcelVerbiage = useSelector(selectConfigExpressParcelVerbiage);
  return (
    <Grid
      fluid
      {...rest}
    >
      <Row>
        <Col
          xs={24}
          lg={16}
        >
          <Text className="mb-4">Selected property</Text>
        </Col>
      </Row>
      <Row>
        <Col
          xs={24}
          lg={16}
          className="ph-0"
        >
          <Stack
            direction="column"
            alignItems="flex-start"
            className="pt-8 pb-16 ph-16 selected-property-container"
          >
            <Text className="text-bold mt-12 text-large">
              {propertyDetails?.address}
            </Text>
            <Text>
              {selectedParcelVerbiage}: {propertyDetails?.apn}
            </Text>
          </Stack>
        </Col>
      </Row>
    </Grid>
  );
};

export default SelectedProperty;
